/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {createContext, useContext} from 'react';

/**
 * Provider and associated hook for accessing the Commerce API in React components.
 */
export const ConnectorsContext = createContext();
export const ConnectorsProvider = ConnectorsContext.Provider;
export const useCommerceAPI = () => useContext(ConnectorsContext).commerceAPI;
export const useSfccAPI = () => useContext(ConnectorsContext).sfccAPI;
